/**
 * Route for `offer-preview-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OfferPreviewApiPage } from "../features/offer-preview-api/OfferPreviewApiPage";

export const offerPreviewApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/offer-preview-api",
	component: OfferPreviewApiPage,
});

export default offerPreviewApiRoute;
